import { makeStyles, createStyles } from '@material-ui/styles';

export default makeStyles((theme) => createStyles({
    root: {
        padding: '16px 24px 24px',
        backgroundColor: theme.palette.terragene.darkSecondary,
        borderRadius: 6,
    }
}))